import api from '../api';
import { API_URL } from '../config';

// Get all absence violations
export const getAllAbsenceViolations = async () => {
  const res = await api.get(`${API_URL}/absence-violations`);
  return res.data;
};

// Get absence violation by ID
export const getAbsenceViolationById = async (id) => {
  const res = await api.get(`${API_URL}/absence-violations/${id}`);
  return res.data;
};

// Get absence violation by absence ID
export const getAbsenceViolationByAbsenceId = async (absenceId) => {
  const res = await api.get(`${API_URL}/absence-violations/absence/${absenceId}`);
  return res.data;
};

// Create new absence violation
export const createAbsenceViolation = async (violation) => {
  const res = await api.post(`${API_URL}/absence-violations`, violation);
  return res.data;
};

// Update absence violation
export const updateAbsenceViolation = async (id, violation) => {
  const res = await api.put(`${API_URL}/absence-violations/${id}`, violation);
  return res.data;
};

// Delete absence violation
export const deleteAbsenceViolation = async (id) => {
  const res = await api.delete(`${API_URL}/absence-violations/${id}`);
  return res.data;
};